import * as React from "react";
import styled from "@emotion/styled";
import theme, { switchColor, Themes, BaseStyleAttrs } from "@/theme";

type ButtonProps = {
  color?: Themes;
} & BaseStyleAttrs &
  React.ButtonHTMLAttributes<HTMLButtonElement>;

const StyledButton = styled.button<Pick<ButtonProps, "color"> & BaseStyleAttrs>`
  width: ${({ width = "auto" }) => width};
  height: ${({ height = "24px" }) => height};
  margin: ${({ margin = "0 0 0 0" }) => margin};
  padding: ${({ padding = "0 0 0 0" }) => padding};
  min-width: 20px;
  box-shadow: 0px 1px 3px #0000001a;
  border-radius: 3px;
  opacity: 1;
  text-align: center;
  font-size: 16px;
  letter-spacing: 0px;
  color: ${theme.main.lightWhite};
  font-size: 14px;
  font-weight: bold;
  line-height: 24px;
  border: none;
  outline: none;
  background-color: ${({ color = "dark" as Themes }) => switchColor(color)};
  cursor: pointer;

  &:active {
    opacity: 0.9;
  }

  &:hover {
    opacity: 0.8;
  }
`;

const Button = ({ ...props }: ButtonProps) => {
  return <StyledButton {...props} />;
};

export default Button;
